module.exports = __webpack_public_path__ + "media/stylesheets/images/writer4-60fd211fce170a4852f8c91321cd64ec.jpg";